<template>
    <div class="px-2.5 font-poppins max-h-[70vh] 2xl:max-h-auto overflow-y-auto customScrollbar">
        <h4 class="font-semibold text-sm font-poppins mb-1.5">Share this checkout link with your customer to complete their purchase.</h4>
        <div
            class="relative w-full h-[42px] rounded-lg !border !border-[#ccc] bg-[#EFEFEF80]/50">
            <input type="text" v-model="url" ref="shareinput"
                class="w-full h-full p-1.5 2xl:p-2.5 !border-0 outline-none !text-sm !text-[#666666]" disabled>
            <button @click="copysharelink"
                class="absolute top-0 -right-[1px] h-full w-[42px] rounded-r-lg flex items-center justify-center bg-[#F5B134]">
                <img src="../../assets/images/copy-icon.png" alt="Share Icon" class="w-6 h-6">
            </button>
        </div>
        <p class="text-xs font-normal mt-2.5 text-[#666666]">
            The cart is already set up—your customer just needs to log in and continue checkout.
        </p>
        <div class="w-[80px] h-[5px] rounded-full mx-auto mt-2.5 tablet:mt-3 laptop:mt-4 bg-customBlue-100"></div>
        <div class="flex flex-wrap justify-between mt-2.5 tablet:mt-3 laptop:mt-4 gap-[10px] laptop:gap-[15px]">
            <div class="w-full">
                <label for="phoneNumber" class="text-[#666666] text-[13px] tablet:text-sm pb-1">Phone Number</label>
                <inputComponent ref="phoneRef" v-model="phone" name="phone" mask="(###) ###-####" type="tel"
                    placeholder="Enter Number" error-message="Invalid phone number" 
                    customClass="!w-full h-[42px] !p-2.5 !rounded-md !border border-[#EFEFEF] !outline-none !text-[12px] largeDesktop:!text-sm !text-[#999999]" />
            </div>
            <div class="w-full">
                <label for="email" class="text-[#666666] text-[13px] tablet:text-sm pb-1">Email</label>
                <inputComponent ref="emailRef" v-model="email" name="email" :regex="$constants.EMAIL_REGEX"
                    error-message="Please enter a valid email address" placeholder="Enter Email"
                    customClass="!w-full h-[42px] !p-2.5 !rounded-md !border border-[#EFEFEF] !outline-none !text-[12px] largeDesktop:!text-sm !text-[#999999]" />
            </div>
        </div>
        <div class="py-2.5 laptop:py-[20px]">
            <label class="flex mobie:items-start space-x-2.5 cursor-pointer">
                <input type="checkbox" v-model="consentGiven" class="peer hidden" />
                <div
                    class="max-w-[28px] max-h-[28px] min-w-[28px] min-h-[28px] !m-0 border-[1px] rounded-[5px] flex items-center justify-center transition border-[#cccccc] peer-checked:bg-[#fff] peer-checked:border-customBlue-100">
                    <svg v-if="consentGiven" xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 laptop:w-[20px] laptop:h-[20px] text-customBlue-100"
                        fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M5 13l4 4L19 7" />
                    </svg>
                </div>
                <span class="text-[13px] laptop:text-[14px] font-normal font-poppins text-left text-[#666666]">
                    By proceeding, I confirm that I have obtained the customer’s explicit consent to share their contact information with MyHappyHome for the purpose of receiving communications about service plans and related offerings. The customer understands that MyHappyHome may contact them via phone, SMS, or email for sales-related purposes.
                </span>
            </label>
        </div>
        <div class="flex justify-center items-center pt-2 laptop:pt-3 largeDesktop:pt-4 gap-3 pb-[10px]">
            <button :disabled="!isValid()" @click="sendSharedURL()" type="button"
                class="w-[110px] h-[44px] flex justify-center items-center text-[14px] laptop:text-[16px] rounded-md CustomYellowBtn disabled:cursor-not-allowed disabled:!border disabled:!border-[#EFEFEF] disabled:!text-[#999999] disabled:bg-[#EFEFEF] disabled:hover:!bg-none disabled:!shadow-none">
                Send</button>
        </div>
        
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { useToast } from "vue-toastification";
const toast = useToast();
import inputComponent from "../../components/partialComponent/inputComponent.vue";
export default {

    components: {
        inputComponent
    },
    props: ["shareProtectionPlans", "reset"],
    data() {
        return {
            consentGiven: false,
            url: '',
            phone: '',
            email: '',
        }
    },
    computed: {
        ...mapGetters([
            
        ]),
    },
    watch: {

        reset: function (data) {
            this.consentGiven = false
            this.url = ''
            this.phone = ''
            this.email = ''
        },

    },
    methods: {
        ...mapActions([
            "getShareProtectionPlanURL",
        ]),
        isValid() {
            let status = true;
            const hasEmail = this.email && this.email.trim().length > 0;
            const hasPhone = this.phone && this.phone.trim().length > 0;

            if (!hasEmail && !hasPhone) {
                status = false;
            }

            if (hasEmail && !this.validateEmail()) {
                status = false;
            }

            if (hasPhone && this.phone.trim().length !== 14) {
                status = false;
            }

            if (this.consentGiven != true) {
                status = false;
            }

            return status;
        },
        copysharelink() {
            navigator.clipboard.writeText(this.url)
            toast.success("Shared URL copied successfully!");

        },
        acceptNumber() {
            var x = this.phone
                .replace(/\D/g, "")
                .match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
            this.phone = !x[2] ?
                x[1] :
                "(" + x[1] + ") " + x[2] + (x[3] ? "-" + x[3] : "");

        },
        isNumber: function (evt) {
            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                evt.preventDefault();
            } else {
                return true;
            }
        },

        validateEmail() {
            var regex = this.$constants.EMAIL_REGEX;
            return regex.test(this.email);
        },

        updateUrl(url) {
            this.url = url
        },

        sendSharedURL() {
            let payload = {
                'email': this.email,
                'phone': this.$helper.extractPhoneNumber(this.phone)
            }
            this.$emit("sendBtnClick", payload);
        },

    }
}
</script>